import Vue from "vue";
import Router from "vue-router";

const Layout = () => import("@/views/layout");
const Home = () => import("@/views/home");

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

Vue.use(Router);

export const navRouterMap = [
  {
    path: "/contentMGT",
    component: Layout,
    redirect: "noredirect",
    name: "contentMGT",
    meta: {
      title: "router.content",
      key: "内容管理",
      icon: require("@/assets/img/cmb_bookstore_mgt.png"),
      requireAuth: true,
    },
    children: [
      {
        path: "bookstack",
        component: () => import("@/views/contentMGT/bookstack"),
        name: "bookstack",
        redirect: "/contentMGT/bookstack/stack",
        meta: { key: "内容管理", title: "router.book", requireAuth: true },
        children: [
          {
            path: "stack",
            name: "stack",
            component: () => import("@/views/contentMGT/bookstack/stack"),
            meta: { key: "内容管理", title: "router.book", requireAuth: true },
          },
          {
            path: "list",
            name: "list",
            component: () => import("@/views/contentMGT/bookstack/list"),
            meta: { key: "内容管理", title: "router.group", requireAuth: true },
          },
        ],
      },
      {
        path: "bookstack/details",
        component: () => import("@/views/contentMGT/bookstack/details"),
        name: "bookDetails",
        meta: { key: "内容管理", requireAuth: true, hidden: true },
      },
      {
        path: "bookstore",
        component: () => import("@/views/contentMGT/bookstore"),
        name: "bookstore",
        meta: {
          key: "内容管理",
          title: "router.store",
          requireAuth: true,
          hidden: true,
        },
      },
      {
        path: "bookstack/addBooks",
        component: () => import("@/views/contentMGT/bookstack/addBooks"),
        name: "addBooks",
        meta: { key: "内容管理", requireAuth: true, hidden: true },
      },
    ],
  },
  {
    path: "/bookStore",
    component: Layout,
    redirect: "noredirect",
    name: "bookStore",
    meta: {
      title: "router.bookstore",
      key: "书城管理",
      icon: require("@/assets/img/cmb_bookstore_mgt.png"),
      requireAuth: true,
    },
    children: [
      {
        path: "vn",
        component: () => import("@/views/bookStore/vn"),
        name: "vn",
        meta: {
          key: "书城管理",
          title: "router.vnBookstore",
          requireAuth: true,
        },
      },
      {
        path: "vn/details",
        component: () => import("@/views/bookStore/vn/details"),
        name: "vnDetails",
        meta: { key: "书城管理", requireAuth: true, hidden: true },
      },
      {
        path: "iGet",
        component: () => import("@/views/bookStore/iGet"),
        name: "iGet",
        meta: {
          key: "书城管理",
          title: "router.iGetBookstore",
          requireAuth: true,
        },
      },
      {
        path: "iGet/details",
        component: () => import("@/views/bookStore/iGet/details"),
        name: "iGetDetails",
        meta: { key: "书城管理", requireAuth: true, hidden: true },
      },
      {
        path: "tw",
        component: () => import("@/views/bookStore/tw"),
        name: "tw",
        meta: {
          key: "书城管理",
          title: "router.twBookstore",
          requireAuth: true,
        },
      },
      {
        path: "tw/details",
        component: () => import("@/views/bookStore/tw/details"),
        name: "twDetails",
        meta: { key: "书城管理", requireAuth: true, hidden: true },
      },
    ],
  },
  {
    path: "/organization",
    component: Layout,
    redirect: "noredirect",
    name: "organization",
    meta: {
      title: "router.org",
      key: "机构管理",
      icon: require("@/assets/img/cmb_org_mgt.png"),
      requireAuth: true,
    },
    children: [
      {
        path: "orgList",
        component: () => import("@/views/organization/orgList"),
        name: "orgList",
        meta: { key: "机构管理", title: "router.orgList", requireAuth: true },
      },
      {
        path: "orgList/details",
        component: () => import("@/views/organization/orgList/details"),
        name: "orgListDetails",
        meta: { key: "机构管理", requireAuth: true, hidden: true },
      },
      {
        path: "orgList/add",
        component: () => import("@/views/organization/orgList/add"),
        name: "orgListAdd",
        meta: { key: "机构管理", requireAuth: true, hidden: true },
      },

      {
        path: "orgTag",
        component: () => import("@/views/organization/orgTag"),
        name: "orgTag",
        meta: { key: "机构管理", title: "router.orgTag", requireAuth: true },
      },
      {
        path: "orgTag/details",
        component: () => import("@/views/organization/orgTag/details"),
        name: "orgTagDetails",
        meta: { key: "机构管理", requireAuth: true, hidden: true },
      },

      {
        path: "bookConfig",
        component: () => import("@/views/organization/bookConfig"),
        name: "bookConfig",
        meta: {
          key: "机构管理",
          title: "router.storeConfig",
          requireAuth: true,
        },
      },
      {
        path: "bookConfig/edit",
        component: () => import("@/views/organization/bookConfig/edit"),
        name: "bookConfigEdit",
        meta: { key: "机构管理", requireAuth: true, hidden: true },
      },
      {
        path: "bookConfig/add",
        component: () => import("@/views/organization/bookConfig/add"),
        name: "bookConfigAdd",
        meta: { key: "机构管理", requireAuth: true, hidden: true },
      },
      {
        path: "bookConfig/batch",
        component: () => import("@/views/organization/bookConfig/batch"),
        name: "bookConfigBatch",
        meta: { key: "机构管理", requireAuth: true, hidden: true },
      },

      // {path: 'appConfig', component: () => import('@/views/organization/appConfig'), name: 'appConfig', meta: {key: '机构管理', title: '超星应用配置', requireAuth: true}},
      // {path: 'appConfig/edit', component: () => import('@/views/organization/appConfig/edit'), name: 'appConfigEdit', meta: {key: '机构管理', requireAuth: true, hidden: true}},
      // {path: 'appConfig/add', component: () => import('@/views/organization/appConfig/add'), name: 'appConfigAdd', meta: {key: '机构管理', requireAuth: true, hidden: true}},
      // {path: 'appConfig/batch', component: () => import('@/views/organization/appConfig/batch'), name: 'appConfigBatch', meta: {key: '机构管理', requireAuth: true, hidden: true}},

      {
        path: "screenConfig",
        component: () => import("@/views/organization/screenConfig"),
        name: "screenConfig",
        meta: {
          key: "机构管理",
          title: "router.screenConfig",
          requireAuth: true,
        },
      },
      {
        path: "screenConfig/edit",
        component: () => import("@/views/organization/screenConfig/edit"),
        name: "screenConfigEdit",
        meta: { key: "机构管理", requireAuth: true, hidden: true },
      },
      {
        path: "screenConfig/batch",
        component: () => import("@/views/organization/screenConfig/batch"),
        name: "screenConfigBatch",
        meta: { key: "机构管理", requireAuth: true, hidden: true },
      },
    ],
  },

  {
    path: "/usersMGT",
    component: Layout,
    redirect: "noredirect",
    name: "usersMGT",
    meta: {
      title: "router.users",
      key: "用户管理",
      icon: require("@/assets/img/cmb_users_mgt.png"),
      requireAuth: true,
    },
    children: [
      {
        path: "users/add",
        component: () => import("@/views/usersMGT/add"),
        name: "add",
        meta: { key: "用户管理", requireAuth: true, hidden: true },
      },
      {
        path: "users",
        component: () => import("@/views/usersMGT/users"),
        name: "users",
        meta: { key: "用户管理", title: "router.users", requireAuth: true },
      },
      {
        path: "roles",
        component: () => import("@/views/usersMGT/roles"),
        name: "roles",
        meta: { key: "用户管理", title: "router.roles", requireAuth: true },
      },
      {
        path: "facilitys",
        component: () => import("@/views/usersMGT/facilitys"),
        name: "facilitys",
        meta: { key: "用户管理", title: "router.device", requireAuth: true },
      },
      {
        path: "facilitys/add",
        component: () => import("@/views/usersMGT/addFacilitys"),
        name: "addFacilitys",
        meta: { key: "用户管理", requireAuth: true, hidden: true },
      },
      {
        path: "facilitys/import",
        component: () => import("@/views/usersMGT/importFacilitys"),
        name: "importFacilitys",
        meta: { key: "用户管理", requireAuth: true, hidden: true },
      },
      {
        path: "smsWhitelist",
        component: () => import("@/views/usersMGT/smsWhitelist"),
        name: "smsWhitelist",
        meta: { key: "用户管理", title: "router.smsWhitelist", requireAuth: true },
      },
    ],
  },
  {
    path: "/versionMGT",
    component: Layout,
    redirect: "noredirect",
    name: "versionMGT",
    meta: {
      title: "router.upgrade",
      key: "固件升级管理",
      icon: require("@/assets/img/cmb_version_mgt.png"),
      requireAuth: true,
    },
    children: [
      {
        path: "version",
        component: () => import("@/views/versionMGT/version"),
        name: "version",
        meta: {
          key: "固件升级管理",
          title: "router.upgrade",
          requireAuth: true,
        },
      },
      {
        path: "update",
        component: () => import("@/views/versionMGT/update"),
        name: "update",
        meta: { key: "固件升级管理", title: "router.update", hidden: true },
      },
    ],
  },
  {
    path: "/statistics",
    component: Layout,
    redirect: "noredirect",
    name: "statistics",
    meta: {
      title: "router.statistics",
      key: "数据统计",
      icon: require("@/assets/img/cmb_data_stats.png"),
      requireAuth: true,
    },
    children: [
      {
        path: "integratedData",
        component: () => import("@/views/statistics/integratedData"),
        name: "integratedData",
        meta: {
          key: "数据统计",
          title: "router.integratedData",
          requireAuth: true,
        },
      },
      {
        path: "ossStats",
        component: () => import("@/views/statistics/ossStats"),
        name: "ossStats",
        meta: {
          key: "数据统计",
          title: "router.ossStats",
          requireAuth: true,
        },
      },
      {
        path: "useInfo",
        component: () => import("@/views/statistics/useInfo"),
        name: "useInfo",
        meta: { key: "数据统计", title: "router.use", requireAuth: true },
      },
      {
        path: "bookstoreStatic",
        component: () => import("@/views/statistics/bookstoreStatic"),
        name: "bookstoreStatic",
        meta: {
          key: "数据统计",
          title: "router.bookstoreStatic",
          requireAuth: true,
        },
      },
      {
        path: "pcInfo",
        component: () => import("@/views/statistics/pcInfo"),
        name: "pcInfo",
        meta: { key: "数据统计", title: "router.pcStats", requireAuth: true },
      },
      {
        path: "wechatIot",
        component: () => import("@/views/statistics/wechatIot"),
        name: "wechatIot",
        meta: { key: "数据统计", title: "router.wechatIot", requireAuth: true },
      },
      // {
      //   path: 'booxCloud',
      //   component: () => import('@/views/statistics/booxCloud'),
      //   name: 'booxCloud',
      //   meta: {
      //     key: '数据统计',
      //     title: 'router.booxCloud',
      //     requireAuth: true
      //   }
      // },
      {
        path: "libraryStats",
        component: () => import("@/views/statistics/libraryStats"),
        name: "libraryStats",
        meta: {
          key: "数据统计",
          title: "router.booxCloud",
          requireAuth: true,
        },
      },
      {
        path: "permissionStat",
        component: () => import("@/views/statistics/permissionStat"),
        name: "permissionStat",
        meta: {
          key: "数据统计",
          title: "router.permissionStat",
          requireAuth: true,
        },
      },
      {
        path: "chatGPT",
        component: () => import("@/views/statistics/chatGPT"),
        name: "chatGPT",
        meta: { key: "数据统计", title: "router.chatGPT", requireAuth: true },
      },

      {
        path: "deviceInfo",
        component: () => import("@/views/statistics/deviceInfo"),
        name: "deviceInfo",
        meta: {
          key: "数据统计",
          title: "router.deviceInfo",
          requireAuth: true,
        },
      },
      {
        path: "couchbase",
        component: () => import("@/views/statistics/couchbase"),
        name: "couchbase",
        meta: { key: "数据统计", title: "router.couchbase", requireAuth: true },
      },
      {
        path: "usePowers",
        component: () => import("@/views/statistics/usePowers"),
        name: "usePowers",
        meta: { key: "数据统计", title: "router.usePowers", requireAuth: true },
      },

      // {
      //   path: "notesInfo",
      //   component: () => import("@/views/statistics/notesInfo"),
      //   name: "notesInfo",
      //   meta: { key: "数据统计", title: "router.notesInfo", requireAuth: true }
      // }
      // {
      //   path: "bookApp",
      //   component: () => import("@/views/statistics/bookApp"),
      //   name: "bookApp",
      //   meta: { key: "数据统计", title: "router.bookApp", requireAuth: true }
      // },
      // {
      //   path: "ranking",
      //   component: () => import("@/views/statistics/ranking"),
      //   name: "ranking",
      //   meta: { key: "数据统计", title: "router.ranking", requireAuth: true }
      // }
    ],
  },
  {
    path: "/market",
    component: Layout,
    redirect: "noredirect",
    name: "market",
    meta: {
      title: "router.market",
      key: "销售相关",
      icon: require("@/assets/img/cmb_maket.png"),
      requireAuth: true,
    },
    children: [
      {
        path: "coupon",
        component: () => import("@/views/market/coupon"),
        name: "coupon",
        meta: { key: "销售相关", title: "router.coupon", requireAuth: true },
      },
      {
        path: "coupon/create",
        component: () => import("@/views/market/coupon/create"),
        name: "createCoupon",
        meta: { key: "销售相关", requireAuth: true, hidden: true },
      },
      {
        path: "order",
        component: () => import("@/views/market/order"),
        name: "order",
        meta: { key: "销售相关", title: "router.order", requireAuth: true },
      },
      {
        path: "advertisement",
        component: () => import("@/views/market/advertisement"),
        name: "advertisement",
        meta: {
          key: "销售相关",
          title: "router.advertisement",
          requireAuth: true,
        },
      },
      {
        path: "advertisement/create",
        component: () => import("@/views/market/advertisement/create"),
        name: "createAds",
        meta: { key: "销售相关", requireAuth: true, hidden: true },
      },
      {
        path: "gift",
        component: () => import("@/views/market/gift"),
        name: "gift",
        meta: {
          key: "销售相关",
          title: "router.gift",
          requireAuth: true,
        },
      },
      {
        path: "gift/create",
        component: () => import("@/views/market/gift/create"),
        name: "createGift",
        meta: { key: "销售相关", requireAuth: true, hidden: true },
      },
      {
        path: "gift/details",
        component: () => import("@/views/market/gift/details"),
        name: "detailsGift",
        meta: { key: "销售相关", requireAuth: true, hidden: true },
      },
      {
        path: "gift/history",
        component: () => import("@/views/market/gift/history"),
        name: "historyGift",
        meta: { key: "销售相关", requireAuth: true, hidden: true },
      },
      {
        path: "card",
        component: () => import("@/views/market/card"),
        name: "card",
        meta: {
          key: "销售相关",
          title: "router.card",
          requireAuth: true,
        },
      },
      {
        path: "card/create",
        component: () => import("@/views/market/card/create"),
        name: "createCard",
        meta: { key: "销售相关", requireAuth: true, hidden: true },
      },
      {
        path: "card/details",
        component: () => import("@/views/market/card/details"),
        name: "detailsCard",
        meta: { key: "销售相关", requireAuth: true, hidden: true },
      },
      {
        path: "card/history",
        component: () => import("@/views/market/card/history"),
        name: "historyCard",
        meta: { key: "销售相关", requireAuth: true, hidden: true },
      },
      {
        path: "appOptimization",
        component: () => import("@/views/market/appOptimization"),
        name: "appOptimization",
        redirect: "/market/appOptimization/godCode",
        meta: {
          key: "销售相关",
          title: "router.appOptimization",
          requireAuth: true,
        },
        children: [
          {
            path: "godCode",
            component: () => import("@/views/deviceMGT/godCode"),
            name: "godCode",
            meta: {
              key: "销售相关",
              title: "router.godCode",
              requireAuth: true,
            },
          },
          {
            path: "appConfTag",
            component: () => import("@/views/deviceMGT/appConfTag"),
            name: "appConfTag",
            meta: {
              key: "销售相关",
              title: "router.appConfTag",
              requireAuth: true,
            },
          },
          {
            path: "appConfTag/create",
            component: () => import("@/views/deviceMGT/appConfTag/create"),
            name: "createAppConfTag",
            meta: { key: "销售相关", requireAuth: true, hidden: true },
          },
          {
            path: "appConfGroup",
            component: () => import("@/views/deviceMGT/appConfGroup"),
            name: "appConfGroup",
            meta: {
              key: "销售相关",
              title: "router.appConfGroup",
              requireAuth: true,
            },
          },
          {
            path: "appConf",
            component: () => import("@/views/deviceMGT/appConf"),
            name: "appConf",
            meta: {
              key: "销售相关",
              title: "router.appConf",
              requireAuth: true,
            },
          },
        ],
      },
      {
        path: "college",
        component: () => import("@/views/college"),
        name: "college",
        redirect: "/market/college/generalSettings",
        meta: {
          key: "销售相关",
          title: "college.title",
          requireAuth: true,
        },
        children: [
          {
            path: "generalSettings",
            component: () => import("@/views/college/generalSettings"),
            name: "generalSettings",
            meta: {
              key: "销售相关",
              title: "college.generalSettings",
              requireAuth: true,
            },
          },
          {
            path: "materialCenterSettings",
            component: () => import("@/views/college/materialCenterSettings"),
            name: "materialCenterSettings",
            meta: {
              key: "销售相关",
              title: "college.materialCenterSettings",
              requireAuth: true,
            },
          },
          {
            path: "template",
            component: () => import("@/views/college/templateMgmt"),
            name: "templateMgmt",
            meta: {
              key: "销售相关",
              title: "college.templateLibrary",
              requireAuth: true,
            },
          },
          {
            path: "sticker",
            component: () => import("@/views/college/stickerMgmt"),
            name: "stickerMgmt",
            meta: {
              key: "销售相关",
              title: "college.stickerLibrary",
              requireAuth: true,
            },
          },
          {
            path: "modelGroup",
            component: () => import("@/views/college/modelGroup"),
            name: "modelGroup",
            meta: {
              key: "销售相关",
              title: "college.modelGroup",
              requireAuth: true,
            },
          },
          {
            path: "modelGroup/create",
            component: () => import("@/views/college/modelGroup/create"),
            name: "createModelGroup",
            meta: { key: "销售相关", requireAuth: true, hidden: true },
          },
        ],
      },
    ],
  },
  {
    path: "/deviceMGT",
    component: Layout,
    redirect: "noredirect",
    name: "deviceMGT",
    meta: {
      title: "router.device",
      key: "设备管理",
      icon: require("@/assets/img/cmb_bookstore_mgt.png"),
      requireAuth: true,
    },
    children: [
      {
        path: "internalDevice",
        component: () => import("@/views/deviceMGT/internalDevice"),
        name: "internalDevice",
        meta: {
          key: "设备管理",
          title: "router.internalDevice",
          requireAuth: true,
        },
      },
      {
        path: "rss",
        component: () => import("@/views/deviceMGT/rss"),
        name: "rss",
        meta: {
          key: "设备管理",
          title: "router.rss",
          requireAuth: true,
        },
      },
      {
        path: "rss/create",
        component: () => import("@/views/deviceMGT/rss/create"),
        name: "createRss",
        meta: { key: "设备管理", requireAuth: true, hidden: true },
      },
      {
        path: "opds",
        component: () => import("@/views/deviceMGT/opds"),
        name: "opds",
        meta: {
          key: "设备管理",
          title: "router.opds",
          requireAuth: true,
        },
      },
      {
        path: "opds/create",
        component: () => import("@/views/deviceMGT/opds/create"),
        name: "createOPDS",
        meta: { key: "设备管理", requireAuth: true, hidden: true },
      },
      {
        path: "devicesModel",
        component: () => import("@/views/deviceMGT/devicesModel"),
        name: "devicesModel",
        meta: {
          key: "设备管理",
          title: "router.devicesModel",
          requireAuth: true,
        },
      },
      {
        path: "devicesModel/create",
        component: () => import("@/views/deviceMGT/devicesModel/create"),
        name: "createDevicesModel",
        meta: { key: "设备管理", requireAuth: true, hidden: true },
      },
      {
        path: "poetry",
        component: () => import("@/views/deviceMGT/poetry"),
        name: "poetry",
        meta: {
          key: "设备管理",
          title: "router.poetry",
          requireAuth: true,
        },
      },
      {
        path: "poetry/create",
        component: () => import("@/views/deviceMGT/poetry/create"),
        name: "createPoetry",
        meta: { key: "设备管理", requireAuth: true, hidden: true },
      },
      {
        path: "poetry/details",
        component: () => import("@/views/deviceMGT/poetry/details"),
        name: "detailsPoetry",
        meta: { key: "设备管理", requireAuth: true, hidden: true },
      },
      {
        path: "poetry/add",
        component: () => import("@/views/deviceMGT/poetry/addDetail"),
        name: "createPoetryDetail",
        meta: { key: "设备管理", requireAuth: true, hidden: true },
      },

      {
        path: "dictionary",
        component: () => import("@/views/deviceMGT/dictionary"),
        name: "dictionary",
        meta: {
          key: "设备管理",
          title: "router.dictionary",
          requireAuth: true,
        },
      },
      {
        path: "dictionary/create",
        component: () => import("@/views/deviceMGT/dictionary/create"),
        name: "createDictionary",
        meta: { key: "设备管理", requireAuth: true, hidden: true },
      },
      {
        path: "dictionary/details",
        component: () => import("@/views/deviceMGT/dictionary/details"),
        name: "detailsDictionary",
        meta: { key: "设备管理", requireAuth: true, hidden: true },
      },
      {
        path: "dictionary/add",
        component: () => import("@/views/deviceMGT/dictionary/addDetail"),
        name: "createDictionaryDetail",
        meta: { key: "设备管理", requireAuth: true, hidden: true },
      },

      {
        path: "motto",
        component: () => import("@/views/deviceMGT/motto"),
        name: "motto",
        meta: {
          key: "设备管理",
          title: "router.motto",
          requireAuth: true,
        },
      },
      {
        path: "motto/create",
        component: () => import("@/views/deviceMGT/motto/create"),
        name: "createMotto",
        meta: { key: "设备管理", requireAuth: true, hidden: true },
      },
      {
        path: "motto/details",
        component: () => import("@/views/deviceMGT/motto/details"),
        name: "detailsMotto",
        meta: { key: "设备管理", requireAuth: true, hidden: true },
      },
      {
        path: "motto/add",
        component: () => import("@/views/deviceMGT/motto/addDetail"),
        name: "createMottoDetail",
        meta: { key: "设备管理", requireAuth: true, hidden: true },
      },
      {
        path: "screensaver",
        component: () => import("@/views/deviceMGT/screensaver"),
        name: "screensaver",
        meta: {
          key: "设备管理",
          title: "router.screensaver",
          requireAuth: true,
        },
      },
      {
        path: "screensaver/create",
        component: () => import("@/views/deviceMGT/screensaver/create"),
        name: "screensaverCreate",
        meta: { key: "设备管理", requireAuth: true, hidden: true },
      },
      {
        path: "writeTemplate",
        component: () => import("@/views/deviceMGT/writeTemplate"),
        name: "writeTemplate",
        meta: {
          key: "设备管理",
          title: "router.writeTemplate",
          requireAuth: true,
        },
      },
      {
        path: "writeTemplate/create",
        component: () => import("@/views/deviceMGT/writeTemplate/create"),
        name: "writeTemplateCreate",
        meta: { key: "设备管理", requireAuth: true, hidden: true },
      },
      {
        path: "devicesModelTag",
        component: () => import("@/views/deviceMGT/devicesModelTag"),
        name: "devicesModelTag",
        meta: {
          key: "设备管理",
          title: "router.devicesModelTag",
          requireAuth: true,
        },
      },
      {
        path: "devicesModelTag/create",
        component: () => import("@/views/deviceMGT/devicesModelTag/create"),
        name: "createDevicesModelTag",
        meta: { key: "设备管理", requireAuth: true, hidden: true },
      },
      {
        path: "devicesPower",
        component: () => import("@/views/deviceMGT/devicesPower"),
        name: "devicesPower",
        meta: {
          key: "设备管理",
          title: "router.devicesPower",
          requireAuth: true,
        },
      },
      {
        path: "devicesPower/create",
        component: () => import("@/views/deviceMGT/devicesPower/create"),
        name: "devicesPowerCreate",
        meta: { key: "设备管理", requireAuth: true, hidden: true },
      },
      {
        path: "lang",
        component: () => import("@/views/deviceMGT/lang"),
        name: "lang",
        meta: {
          key: "设备管理",
          title: "router.lang",
          requireAuth: true,
        },
      },
      {
        path: "staticBook",
        component: () => import("@/views/deviceMGT/staticBook"),
        name: "staticBook",
        meta: {
          key: "设备管理",
          title: "router.staticBook",
          requireAuth: true,
        },
      },
      {
        path: "staticBook/create",
        component: () => import("@/views/deviceMGT/staticBook/create"),
        name: "staticBookCreate",
        meta: { key: "设备管理", requireAuth: true, hidden: true },
      },
      {
        path: "urlParse",
        component: () => import("@/views/deviceMGT/urlParse"),
        name: "urlParse",
        meta: {
          key: "设备管理",
          title: "router.urlParse",
          requireAuth: true,
        },
      },
      {
        path: "urlParse/create",
        component: () => import("@/views/deviceMGT/urlParse/create"),
        name: "urlParseCreate",
        meta: { key: "设备管理", requireAuth: true, hidden: true },
      },
      {
        path: "userRole",
        component: () => import("@/views/deviceMGT/userRole"),
        name: "userRole",
        meta: { key: "设备管理", title: "router.userRole", requireAuth: true },
      },
      {
        path: "sysNotice",
        component: () => import("@/views/deviceMGT/sysNotice"),
        name: "sysNotice",
        meta: { key: "设备管理", title: "router.sysNotice", requireAuth: true },
      },
      {
        path: "sysNotice/operation",
        component: () => import("@/views/deviceMGT/sysNotice/operation"),
        name: "sysNoticeOperation",
        meta: {
          key: "设备管理",
          requireAuth: true,
          hidden: true,
        },
      },
      {
        path: "wechatProduct",
        component: () => import("@/views/deviceMGT/wechatProduct"),
        name: "wechatProduct",
        meta: {
          key: "设备管理",
          title: "router.wechatProduct",
          requireAuth: true,
        },
      },
      {
        path: "wechatProduct/operation",
        component: () => import("@/views/deviceMGT/wechatProduct/operation"),
        name: "wechatProductOperation",
        meta: {
          key: "设备管理",
          requireAuth: true,
          hidden: true,
        },
      },
    ],
  },
  {
    path: "/feedback",
    component: Layout,
    redirect: "noredirect",
    name: "feedback",
    meta: {
      title: "router.feedback",
      key: "信息反馈",
      icon: require("@/assets/img/cmb_bookstore_mgt.png"),
      requireAuth: true,
    },
    children: [
      {
        path: "info",
        component: () => import("@/views/feedback/info"),
        name: "feedbackInfo",
        meta: { key: "信息反馈", title: "router.feedback", requireAuth: true },
      },
      {
        path: "feedbackInfo",
        component: () => import("@/views/feedback/feedbackInfo"),
        name: "feedbackCbInfo",
        meta: {
          key: "信息反馈",
          title: "router.feedbackInfo",
          requireAuth: true,
        },
      },
      {
        path: "feedbackTag",
        component: () => import("@/views/feedback/tag"),
        name: "feedbackTag",
        meta: {
          key: "信息反馈",
          title: "router.feedbackTag",
          requireAuth: true,
        },
      },
      {
        path: "setting",
        component: () => import("@/views/feedback/setting"),
        name: "feedbackSetting",
        meta: { key: "信息反馈", title: "router.setting", requireAuth: true },
      },
      {
        path: "thank",
        component: () => import("@/views/feedback/thank"),
        name: "feedbackThank",
        meta: { key: "信息反馈", title: "router.thank", requireAuth: true },
      },
      {
        path: "thank/add",
        component: () => import("@/views/feedback/thank/add.vue"),
        name: "thankAdd",
        meta: {
          key: "信息反馈",
          title: "router.thank",
          requireAuth: true,
          hidden: true,
        },
      },
      {
        path: "cookieContent",
        component: () => import("@/views/feedback/cookieContent"),
        name: "cookieContent",
        meta: {
          key: "信息反馈",
          title: "router.cookieContent",
          requireAuth: true,
        },
      },
      {
        path: "cookieContent/add",
        component: () => import("@/views/feedback/cookieContent/add.vue"),
        name: "cookieContentAdd",
        meta: {
          key: "信息反馈",
          requireAuth: true,
          hidden: true,
        },
      },
      {
        path: "gptContent",
        component: () => import("@/views/feedback/gptContent"),
        name: "gptContent",
        meta: {
          key: "信息反馈",
          title: "router.gptContent",
          requireAuth: true,
        },
      },
      {
        path: "gptContent/addGptPrompt",
        component: () => import("@/views/feedback/gptContent/gptPrompt/add"),
        name: "addGptPrompt",
        meta: {
          key: "信息反馈",
          requireAuth: true,
          hidden: true,
        },
      },
      {
        path: "faq",
        component: () => import("@/views/feedback/faq"),
        name: "faq",
        meta: { key: "信息反馈", title: "router.faq", requireAuth: true },
      },
      {
        path: "faq/add",
        component: () => import("@/views/feedback/faq/add.vue"),
        name: "faqAdd",
        meta: {
          key: "信息反馈",
          title: "router.faq",
          requireAuth: true,
          hidden: true,
        },
      },
      {
        path: "introduction",
        component: () => import("@/views/feedback/introduction"),
        name: "introduction",
        meta: {
          key: "信息反馈",
          title: "router.introduction",
          requireAuth: true,
        },
      },
      {
        path: "introduction/add",
        component: () => import("@/views/feedback/introduction/add.vue"),
        name: "introductionAdd",
        meta: {
          key: "信息反馈",
          title: "router.introduction",
          requireAuth: true,
          hidden: true,
        },
      },
      {
        path: "manual",
        component: () => import("@/views/feedback/manual"),
        name: "manual",
        meta: {
          key: "信息反馈",
          title: "router.manual",
          requireAuth: true,
        },
      },
      {
        path: "manual/create",
        component: () => import("@/views/feedback/manual/create.vue"),
        name: "createManual",
        meta: {
          key: "信息反馈",
          requireAuth: true,
          hidden: true,
        },
      },
      // {
      //   path: "screen",
      //   component: () => import("@/views/feedback/screen"),
      //   name: "投屏说明",
      //   meta: { key: "投屏说明", title: "router.screen", requireAuth: true }
      // },
      // {
      //   path: "screen/add",
      //   component: () => import("@/views/feedback/screen/add.vue"),
      //   name: "screenAdd",
      //   meta: {
      //     key: "投屏说明",
      //     title: "router.screen",
      //     requireAuth: true,
      //     hidden: true
      //   }
      // },
      // {
      //   path: "privacy",
      //   component: () => import("@/views/feedback/privacy"),
      //   name: "privacy",
      //   meta: { key: "信息反馈", title: "router.privacy", requireAuth: true }
      // },
      // {
      //   path: "privacy/add",
      //   component: () => import("@/views/feedback/privacy/add.vue"),
      //   name: "privacyAdd",
      //   meta: {
      //     key: "信息反馈",
      //     title: "router.privacy",
      //     requireAuth: true,
      //     hidden: true
      //   }
      // }
    ],
  },
  {
    path: "/boox",
    component: Layout,
    redirect: "noredirect",
    name: "boox",
    meta: {
      title: "router.boox",
      key: "BOOX助手",
      icon: require("@/assets/img/cmb_bookstore_mgt.png"),
      requireAuth: true,
    },
    children: [
      {
        path: "booxApp",
        component: () => import("@/views/BOOX/booxApp"),
        name: "booxApp",
        meta: { key: "BOOX助手", title: "router.booxApp", requireAuth: true },
      },
      {
        path: "booxBanner",
        component: () => import("@/views/BOOX/booxBanner"),
        name: "booxBanner",
        meta: { key: "BOOX助手", title: "router.booxAdv", requireAuth: true },
      },
      {
        path: "booxApp/create",
        component: () => import("@/views/BOOX/create"),
        name: "createBoox",
        meta: { key: "BOOX助手", requireAuth: true, hidden: true },
      },
      {
        path: "booxApp/add",
        component: () => import("@/views/BOOX/create/add"),
        name: "addBoox",
        meta: { key: "BOOX助手", requireAuth: true, hidden: true },
      },
      {
        path: "booxApp/createExtension",
        component: () => import("@/views/BOOX/create/createExtension"),
        name: "createExtension",
        meta: { key: "BOOX助手", requireAuth: true, hidden: true },
      },
      {
        path: "booxVersions",
        component: () => import("@/views/BOOX/booxVersions"),
        name: "booxVersions",
        meta: {
          key: "BOOX助手",
          title: "router.booxVersions",
          requireAuth: true,
        },
      },
      {
        path: "booxVersions/create",
        component: () => import("@/views/BOOX/booxVersions/create"),
        name: "booxVersionsCreate",
        meta: { key: "BOOX助手", requireAuth: true, hidden: true },
      },
      {
        path: "loginAds",
        component: () => import("@/views/BOOX/loginAds"),
        name: "loginAds",
        meta: {
          key: "BOOX助手",
          title: "router.loginAds",
          requireAuth: true,
        },
      },
      {
        path: "loginAds/create",
        component: () => import("@/views/BOOX/loginAds/create"),
        name: "loginAdsCreate",
        meta: { key: "BOOX助手", requireAuth: true, hidden: true },
      },
      {
        path: "booxClient",
        component: () => import("@/views/BOOX/booxClient"),
        name: "booxClient",
        meta: {
          key: "BOOX助手",
          title: "router.booxClient",
          requireAuth: true,
        },
      },
      {
        path: "booxClient/create",
        component: () => import("@/views/BOOX/booxClient/create"),
        name: "booxClientCreate",
        meta: { key: "BOOX助手", requireAuth: true, hidden: true },
      },
    ],
  },
  {
    path: "/updateList",
    component: Layout,
    redirect: "noredirect",
    name: "updateList",
    meta: {
      title: "router.updateList",
      key: "更新记录",
      icon: require("@/assets/img/cmb_bookstore_mgt.png"),
      requireAuth: true,
    },
    children: [
      {
        path: "publish",
        component: () => import("@/views/update/publish"),
        name: "publish",
        meta: {
          key: "更新记录",
          title: "router.updatePublish",
          requireAuth: true,
        },
      },
      {
        path: "publish/add",
        component: () => import("@/views/update/publish/add.vue"),
        name: "publishAdd",
        meta: {
          key: "更新记录",
          title: "router.updateAdd",
          requireAuth: true,
          hidden: true,
        },
      },
      {
        path: "test",
        component: () => import("@/views/update/test"),
        name: "test",
        meta: {
          key: "更新记录",
          title: "router.updateTest",
          requireAuth: true,
        },
      },
      {
        path: "test/add",
        component: () => import("@/views/update/test/add.vue"),
        name: "testAdd",
        meta: {
          key: "更新记录",
          title: "router.updateAdd",
          requireAuth: true,
          hidden: true,
        },
      },
      {
        path: "apply",
        component: () => import("@/views/update/apply"),
        name: "apply",
        meta: {
          key: "更新记录",
          title: "router.updateApply",
          requireAuth: true,
        },
      },
      {
        path: "apply/add",
        component: () => import("@/views/update/apply/add.vue"),
        name: "applyAdd",
        meta: {
          key: "更新记录",
          title: "router.updateAdd",
          requireAuth: true,
          hidden: true,
        },
      },
      {
        path: "view",
        component: () => import("@/views/update/view"),
        name: "updateView",
        meta: {
          key: "更新记录",
          title: "router.updateAdd",
          requireAuth: true,
          hidden: true,
        },
      },
    ],
  },
  {
    path: "/serverMGT",
    component: Layout,
    redirect: "noredirect",
    name: "serverMGT",
    meta: {
      title: "router.serverMGT",
      key: "服务器管理",
      icon: require("@/assets/img/cmb_bookstore_mgt.png"),
      requireAuth: true,
    },
    children: [
      {
        path: "list",
        component: () => import("@/views/serverMGT"),
        name: "serverList",
        meta: {
          key: "服务器管理",
          title: "router.serverMGT",
          requireAuth: true,
        },
      },
      {
        path: "list/add",
        component: () => import("@/views/serverMGT/add.vue"),
        name: "serverAdd",
        meta: {
          key: "服务器管理",
          title: "router.serverMGT",
          requireAuth: true,
          hidden: true,
        },
      },
      {
        path: "searchSite",
        component: () => import("@/views/serverMGT/searchSite"),
        name: "searchSite",
        meta: {
          key: "服务器管理",
          title: "router.searchSite",
          requireAuth: true,
        },
      },
      {
        path: "searchSite/add",
        component: () => import("@/views/serverMGT/searchSite/add.vue"),
        name: "searchSiteAdd",
        meta: {
          key: "服务器管理",
          title: "router.serverMGT",
          requireAuth: true,
          hidden: true,
        },
      },
      {
        path: "testGroup",
        component: () => import("@/views/serverMGT/testGroup"),
        name: "testGroup",
        meta: {
          key: "服务器管理",
          title: "router.testGroup",
          requireAuth: true,
        },
      },
      {
        path: "testGroup/add",
        component: () => import("@/views/serverMGT/testGroup/add.vue"),
        name: "testGroupAdd",
        meta: {
          key: "服务器管理",
          requireAuth: true,
          hidden: true,
        },
      },
    ],
  },
  {
    path: "/serviceConfig",
    component: Layout,
    redirect: "noredirect",
    name: "serviceConfig",
    meta: {
      title: "router.serviceConfig",
      key: "服务配置管理",
      icon: require("@/assets/img/cmb_bookstore_mgt.png"),
      requireAuth: true,
    },
    children: [
      {
        path: "thirdParty",
        component: () => import("@/views/serviceConfig/thirdParty/list.vue"),
        name: "thirdPartyList",
        meta: {
          key: "服务配置管理",
          title: "router.thirdParty",
          requireAuth: true,
        },
      },
      {
        path: "thirdParty/add",
        component: () => import("@/views/serviceConfig/thirdParty/add.vue"),
        name: "thirdPartyAdd",
        meta: {
          key: "服务配置管理",
          title: "router.thirdParty",
          requireAuth: true,
          hidden: true,
        },
      },
      {
        path: "ddosWarning",
        component: () => import("@/views/serviceConfig/ddosWarning/list.vue"),
        name: "ddosWarningList",
        meta: {
          key: "服务配置管理",
          title: "router.ddosWarning",
          requireAuth: true,
        },
      },
      {
        path: "ddosWarning/add",
        component: () => import("@/views/serviceConfig/ddosWarning/add.vue"),
        name: "ddosWarningAdd",
        meta: {
          key: "服务配置管理",
          requireAuth: true,
          hidden: true,
        },
      },
      {
        path: "accessBlack",
        component: () => import("@/views/serviceConfig/accessBlack/list.vue"),
        name: "accessBlackList",
        meta: {
          key: "服务配置管理",
          title: "router.accessBlack",
          requireAuth: true,
        },
      },
      {
        path: "accessBlack/add",
        component: () => import("@/views/serviceConfig/accessBlack/add.vue"),
        name: "accessBlackAdd",
        meta: {
          key: "服务配置管理",
          requireAuth: true,
          hidden: true,
        },
      },
      {
        path: "systemConfig",
        component: () => import("@/views/serviceConfig/systemConfig/add.vue"),
        name: "systemConfig",
        meta: {
          key: "服务配置管理",
          title: "router.systemConfig",
          requireAuth: true,
        },
      },
      {
        path: "adminConfig",
        component: () => import("@/views/serviceConfig/adminConfig"),
        name: "adminConfig",
        meta: {
          key: "服务配置管理",
          title: "router.adminConfig",
          requireAuth: true,
        },
      },
      {
        path: "adminConfig/add",
        component: () => import("@/views/serviceConfig/adminConfig/add"),
        name: "addAdminConfig",
        meta: {
          key: "服务配置管理",
          requireAuth: true,
          hidden: true,
        },
      },
    ],
  },

  // {
  //   path: '/cxApp',
  //   component: Layout,
  //   redirect: 'noredirect',
  //   name: 'cxApp',
  //   meta: {
  //     title: '超星应用管理',
  //     key: '超星应用管理',
  //     icon: require('@/assets/img/cmb_app_mgt.png'),
  //     requireAuth: true
  //   },
  //   children: [
  //     {path: 'appMGT', component: () => import('@/views/appMGT/appMGT'), name: 'appMGT', meta: {key: '超星应用管理', title: '应用管理', requireAuth: true}}
  //   ]
  // },
  // {
  //   path: '/mobileMGT',
  //   component: Layout,
  //   redirect: 'noredirect',
  //   name: 'mobileMGT',
  //   meta: {
  //     title: '移动端管理',
  //      key: '移动端管理',
  //     icon: require('@/assets/img/cmb_mobile_mgt.png'),
  //     requireAuth: true
  //   },
  //   children: [
  //     {path: 'classify', component: () => import('@/views/mobileMGT/classify'), name: 'classify', meta: {key: '移动端管理', title: '分类管理', requireAuth: true}},
  //     {path: 'bookList', component: () => import('@/views/mobileMGT/bookList'), name: 'bookList', meta: {key: '移动端管理', title: '专题书单', requireAuth: true}},
  //     {path: 'carousel', component: () => import('@/views/mobileMGT/carousel'), name: 'carousel', meta: {key: '移动端管理', title: '轮播图管理', requireAuth: true}},
  //   ]
  // }
];

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      component: () => import("@/views/login"),
      name: "login",
    },
    {
      path: "/reset",
      component: () => import("@/views/reset"),
      name: "reset",
    },
    {
      path: "/errorPage",
      component: () => import("@/views/errorPage"),
      name: "errorPage",
    },
    {
      path: "/",
      component: Layout,
      redirect: "/contentMGT/bookstack/stack",
      children: [
        {
          path: "index",
          component: Home,
          name: "Home",
          meta: { requireAuth: true },
        },
      ],
    },
    ...navRouterMap,
  ],
});
